(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ags-dispatch-strip"] && !Shopify.designMode) return;
  try {
    (() => {
  const update = () => {
    const parts = new Intl.DateTimeFormat('en-CA',{timeZone:'Europe/Madrid',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(new Date());
    const values = Object.fromEntries(parts.map(p => [p.type,p.value]));
    const tomorrow = new Date(Date.UTC(Number(values.year),Number(values.month)-1,Number(values.day)+1,12));
    const days = ['dom','lun','mar','mié','jue','vie','sáb'];
    const months = ['ene','feb','mar','abr','may','jun','jul','ago','sep','oct','nov','dic'];
    const label = days[tomorrow.getUTCDay()]+', '+tomorrow.getUTCDate()+' '+months[tomorrow.getUTCMonth()];
    document.querySelectorAll('[data-ags-dispatch-date]').forEach(el => { el.textContent = label; });
  };
  update();
  document.addEventListener('shopify:section:load',update);
  document.addEventListener('visibilitychange',update);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ags-example-reviews"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ags-example-reviews')) {
customElements.define('ags-example-reviews', class extends HTMLElement {
 connectedCallback() {
  if (this.ready) return;
  this.ready = true;
  const desktopMotion = matchMedia('(min-width: 1024px)');
    const track = this.querySelector('.ags-example-reviews__track');
  const group = track.firstElementChild;
  const copy = group.cloneNode(true);
  copy.setAttribute('aria-hidden','true');
  track.appendChild(copy);
  let span = 0, position = 0, previous = 0;
  this.resizeObserver = new ResizeObserver(() => {
   span = copy.offsetLeft - group.offsetLeft;
   if (span) position %= span;
  });
  this.resizeObserver.observe(track);
  const tick = now => {
   const elapsed = previous ? Math.min(now - previous,64) : 0;
   previous = now;
   if (span && !document.hidden) position = (position + (desktopMotion.matches ? 627.3 : 262.98) * elapsed / 1000) % span;
   track.style.transform = 'translate3d(' + (-position) + 'px,0,0)';
   this.animationFrame = requestAnimationFrame(tick);
  };
  this.animationFrame = requestAnimationFrame(tick);
 }
 disconnectedCallback() {
  cancelAnimationFrame(this.animationFrame);
  if (this.resizeObserver) this.resizeObserver.disconnect();
  const track = this.querySelector('.ags-example-reviews__track');
  while (track && track.children.length > 1) track.lastElementChild.remove();
  this.ready = false;
 }
});
}
  } catch(e) { console.error(e); }
})();

})();
